<template>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h3 class="modal-title">Добавить ингредиент</h3>
        <button type="button" class="close" @click="$emit('hide')" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="form-group">
          <label>Ингредиент</label>
        <server-select
          v-model="component"
          placeholder="Выберите ингредиент..."
          endpoint="components/options"
          label="name"
        />
        </div>
      </div>
      <div class="modal-footer d-flex">
          <btn-action
            class="btn btn-outline-primary ml-auto"
            :disabled="!component"
            @click="save"
          >Сохранить</btn-action>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    data () {
      return {
        component: null,
      }
    },
    methods: {
      save () {
        this.$emit('hide', {
          component: this.component,
        })
      }
    },
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/recipes/product-modal.vue